import {NS} from 'entities/Car'

export const SAMPLE_BREND_MODELS: NS.IServerBrend['models'] = [
    {
        id: 0,
        name: '',
        advertisement_count: 20,
        photo: null,
    },
    {
        id: 0,
        name: '',
        advertisement_count: 15,
        photo: null,
    },
    {
        id: 0,
        name: '',
        advertisement_count: 0,
        photo: null,
    },
    {
        id: 0,
        name: '',
        advertisement_count: 0,
        photo: null,
    },
    {
        id: 0,
        name: '',
        advertisement_count: 0,
        photo: null,
    },{
        id: 0,
        name: '',
        advertisement_count: 0,
        photo: null,
    }

]